import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config/config";


export const fetchHomepageConfig = createAsyncThunk(
  "uiContent/fetchHomepageConfig",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${config.backendUrl}/uicontent/homepage_config`);
      // Return data if it exists, otherwise return null
      if (response.data && response.data.success && response.data.data) {
        return response.data.data;
      }
      return null;
    } catch (err) {
      console.error("Failed to fetch UI content:", err);
      // Return null on error
      return null; 
    }
  }
);

export const updateHomepageConfig = createAsyncThunk(
  "uiContent/updateHomepageConfig",
  async (payload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("adminToken");
      const response = await axios.put(
        `${config.backendUrl}/uicontent/homepage_config`,
        { value: payload },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      if (response.data && response.data.success) {
        return response.data.data;
      }
      return rejectWithValue("Failed to update config");
    } catch (err) {
      console.error("Error updating config", err);
      return rejectWithValue(err.response?.data?.message || "Error updating config");
    }
  }
);

const uiContentSlice = createSlice({
  name: "uiContent",
  initialState: {
    homepageConfig: null,
    loading: true,
    updateLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchHomepageConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHomepageConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.homepageConfig = action.payload;
      })
      .addCase(fetchHomepageConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update
      .addCase(updateHomepageConfig.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateHomepageConfig.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.homepageConfig = action.payload;
      })
      .addCase(updateHomepageConfig.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
      });
  }
});

export default uiContentSlice.reducer;
